import { render, staticRenderFns } from "./ComponentWaitItem.vue?vue&type=template&id=0cd51565&scoped=true"
import script from "./ComponentWaitItem.vue?vue&type=script&lang=js"
export * from "./ComponentWaitItem.vue?vue&type=script&lang=js"
import style0 from "./ComponentWaitItem.vue?vue&type=style&index=0&id=0cd51565&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd51565",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd51565')) {
      api.createRecord('0cd51565', component.options)
    } else {
      api.reload('0cd51565', component.options)
    }
    module.hot.accept("./ComponentWaitItem.vue?vue&type=template&id=0cd51565&scoped=true", function () {
      api.rerender('0cd51565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/edit/ComponentWaitItem.vue"
export default component.exports